import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { validators, formats, dates } from 'investira.sdk';
import { Button, IconButton, Tooltip, Stack, Icon, Chip } from 'investira.react.components';
import { BulkContextActions, DataTable } from '../';
import usePerfil from '../../../hooks/usePerfil';

const AvaliacoesDataGrid = props => {
  const {
    state,
    output_id,
    onEditClick,
    onBulkDeleteClick,
    onDeleteClick,
    onSwitchChange,
    renderDetailPanel,
    data,
    ...restProps
  } = props;

  const { usuarioPrioridade } = usePerfil();

  const columns = useMemo(
    () => [
      {
        accessorKey: 'gestor',
        header: 'Gestor',
        enableColumnActions: false,
        enableSorting: false,
        muiTableHeadCellProps: {
          sx: {
            width: '100% !important'
          }
        },
        Cell: ({ cell }) => {
          if (validators.isNull(cell.getValue())) {
            return;
          }
          return cell.getValue();
        }
      },
      {
        accessorKey: 'fundo',
        header: 'Fundo',
        enableColumnActions: false,
        enableSorting: false,
        muiTableHeadCellProps: {
          sx: {
            width: '100% !important'
          }
        },
        Cell: ({ cell }) => {
          if (validators.isNull(cell.getValue())) {
            return;
          }
          return cell.getValue();
        }
      },
      {
        accessorKey: 'status',
        header: 'Status',
        enableColumnActions: false,
        enableSorting: false,
        Cell: ({ cell }) => {
          if (validators.isNull(cell.getValue())) {
            return;
          }

          return (
            <Chip
              size="small"
              label={cell.getValue()}
              color={
                cell.getValue() === 'Rascunho'
                  ? 'warning'
                  : cell.getValue() === 'Pendente'
                  ? 'info'
                  : 'success'
              }
            />
          );
        }
      },
      {
        accessorKey: 'score',
        header: 'Score',
        enableColumnActions: false,
        enableSorting: false,
        size: 40,
        Cell: ({ cell }) => {
          if (validators.isNull(cell.getValue())) {
            return;
          }
          return (
            <Chip
              size="small"
              label={cell.getValue()}
              color={
                cell.getValue() < 1.8
                  ? 'error'
                  : cell.getValue() < 2.2
                  ? 'warning'
                  : cell.getValue() < 3
                  ? 'info'
                  : 'primary'
              }
            />
          );
        }
      },
      {
        accessorKey: 'modified',
        header: 'Última Modificação',
        enableColumnActions: false,
        enableSorting: false,
        Cell: ({ cell }) => {
          if (validators.isNull(cell.getValue())) {
            return;
          }
          return cell.getValue();
        }
      },
      {
        accessorKey: 'reenvio',
        header: 'Reenvio',
        enableColumnActions: false,
        enableSorting: false,
        Cell: ({ cell }) => {
          if (!cell.getValue()) {
            return;
          }
          return (
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={() => {
                // TODO: implementar a ação que o botão deve realizar
              }}>
              Reenviar email
            </Button>
          );
        }
      }
    ],
    []
  );

  const xProps = {
    columns,
    data,
    state,
    enableRowSelection: usuarioPrioridade <= 6,
    displayColumnDefOptions: {
      'mrt-row-actions': {
        header: ''
      }
    },
    renderTopToolbarCustomActions: ({ table }) => {
      if (usuarioPrioridade > 6) {
        return null;
      }

      const selectedRows = table.getSelectedRowModel().rows;
      const isSomeRowSelected = selectedRows.length > 0;

      return (
        <BulkContextActions
          onDeleteClick={() => {
            onBulkDeleteClick(selectedRows);
          }}
          disabled={state.isLoading || state.showProgressBars || !isSomeRowSelected}
        />
      );
    },
    renderRowActions: ({ row }) => {
      return (
        <Stack direction="row" spacing={2}>
          <Tooltip title="Editar Rascunho">
            <IconButton color="primary" onClick={() => onEditClick(row.original)}>
              <Icon iconName="edit" size={21} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Visualizar Avaliação">
            <IconButton color="primary" onClick={() => onEditClick(row.original)}>
              <Icon iconName="eye" size={21} />
            </IconButton>
          </Tooltip>
        </Stack>
      );
    },
    ...restProps
  };

  return <DataTable {...xProps} />;
};

AvaliacoesDataGrid.propTypes = {
  data: PropTypes.array.isRequired,
  state: PropTypes.object,
  initialState: PropTypes.object
};

export default AvaliacoesDataGrid;
